import { render } from "./TransformerProformaPage.vue?vue&type=template&id=7220ecad&ts=true"
import script from "./TransformerProformaPage.vue?vue&type=script&lang=ts"
export * from "./TransformerProformaPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__